import {Action} from '@ngrx/store';

export enum ActionTypes {
  KPI_STAT_REQUESTED = '[KPI Stat] Data Request',
  KPI_STAT_FAILURE = '[KPI Stat] Data Failure',
  KPI_STAT_SUCCESS = '[KPI Stat] Data Success',
  KPI_STAT_UPDATED = '[KPI Stat] Data Updated',
}

export class KpiStatRequested implements Action {
  readonly type = ActionTypes.KPI_STAT_REQUESTED;

  constructor(public payload: {statName: string; param?: string; dateRange?: number[]; tab: string}) {}
}

export class KpiStatFailure implements Action {
  readonly type = ActionTypes.KPI_STAT_FAILURE;

  constructor(public payload: {error: string}) {}
}

export class KpiStatSuccess implements Action {
  readonly type = ActionTypes.KPI_STAT_SUCCESS;

  constructor(public payload: any) {}
}
export class KpiStatUpdated implements Action {
  readonly type = ActionTypes.KPI_STAT_UPDATED;

  constructor(public payload: any) {}
}

export type Actions = KpiStatRequested | KpiStatFailure | KpiStatSuccess | KpiStatUpdated;
